import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { useAuth } from '../../services/AuthProvider'
import { logo } from '../../pdf/Imges';

function Header() {
    const logout = useAuth().logOut;
    return (
        <>
            <Navbar bg="primary" data-bs-theme="dark">
                <Container>
                    <Nav className="me-auto">
                        <Nav.Link href="/recherche">Recherche</Nav.Link>
                        <Nav.Link onClick={logout}>Déconnexion</Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            <br />
        </>
    )
}

export default Header